import produce from 'immer';
import {
  SET_NEW_CONTACT_BUSINESS_INFORMATION,
  SET_NEW_BUSINESS_INFORMATION,
  SET_NEW_OWNERSHIP_BUSINESS_INFORMATION,
  SET_NEW_DEMPGRAPHIC_BUSINESS_INFORMATION,
  SET_NEW_DEMPGRAPHIC_BUSINESS_ADDRESS_INFORMATION,
  SET_NEW_DEMPGRAPHIC_MAILING_ADDRESS_INFORMATION,
  SET_NEW_OWNERSHIP_OWNER_INFORMATION,
  SET_NEW_OWNERSHIP_OWNER_ADDRESS_INFORMATION,
  SET_NEW_DEPOSIT_BANK_INFORMATION,
  SET_NEW_WITHDRAWAL_BANK_INFORMATION,
} from '../actions/bluepay';


const initialState = {
  templateId: 0,
  merchant: {
    salesCode: '',
    dbaName: '',
    legalBusinessName: '',
    taxFilingName: '',
    taxFilingMethod: '',
    ownership: {
      owner: {
        ownerAddress: {}
      }
    },
    demographic: {
      businessAddress: {},
      mailingAddress: {}
    },
    bankDetail: {
      depositBank: {},
      withdrawalBank: {}
    }
  },
  loadingMerchant: false,
  errorMerchant: false,
};

const formReducer = produce((state = initialState, action) => {
  switch (action.type) {
    case SET_NEW_BUSINESS_INFORMATION: {
      const {keyName, value} = action;
      state.merchant = {...state.merchant, [keyName]: value};
      break;
    }
    case SET_NEW_CONTACT_BUSINESS_INFORMATION: {
      const {keyName, value} = action;
      state.merchant.merchantContactInfo = {...state.merchant.merchantContactInfo, [keyName]: value};
      break;
    }
    case SET_NEW_OWNERSHIP_BUSINESS_INFORMATION: {
      const {keyName, value} = action;
      state.merchant.ownership = {...state.merchant.ownership, [keyName]: value};
      break;
    }
    case SET_NEW_DEMPGRAPHIC_BUSINESS_INFORMATION: {
      const {keyName, value} = action;
      state.merchant.demographic = {...state.merchant.demographic, [keyName]: value};
      break;
    }
    case SET_NEW_DEMPGRAPHIC_BUSINESS_ADDRESS_INFORMATION: {
      const {keyName, value} = action;
      state.merchant.demographic.businessAddress = {...state.merchant.demographic.businessAddress, [keyName]: value};
      break;
    }
    case SET_NEW_DEMPGRAPHIC_MAILING_ADDRESS_INFORMATION: {
      const {keyName, value} = action;
      state.merchant.demographic.mailingAddress = {...state.merchant.demographic.mailingAddress, [keyName]: value};
      break;
    }
    case SET_NEW_OWNERSHIP_OWNER_INFORMATION: {
      const {keyName, value} = action;
      state.merchant.ownership.owner = {...state.merchant.ownership.owner, [keyName]: value};
      break;
    }
    case SET_NEW_OWNERSHIP_OWNER_ADDRESS_INFORMATION: {
      const {keyName, value} = action;
      state.merchant.ownership.owner.ownerAddress = {...state.merchant.ownership.owner.ownerAddress, [keyName]: value};
      break;
    }
    case SET_NEW_DEPOSIT_BANK_INFORMATION: {
      const {keyName, value} = action;
      state.merchant.bankDetail.depositBank = {...state.merchant.bankDetail.depositBank, [keyName]: value};
      break;
    }
    case SET_NEW_WITHDRAWAL_BANK_INFORMATION: {
      const {keyName, value} = action;
      state.merchant.bankDetail.withdrawalBank = {...state.merchant.bankDetail.withdrawalBank, [keyName]: value};
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
